export enum MarketingAuthStatusEnum {
  authorized = "authorized",
  suspended = "suspended",
  revoked = "revoked",
}

export enum NonSubstitutedMedicinesEnum {
  biologicals = "biologicals",
  narrowTherapeuticMargin = "narrowTherapeuticMargin",
  forTheRespiratorySystem = "forTheRespiratorySystem",
}

export interface MedicineSearchModel {
  registration_number: string,
}

export interface MedicinesSearchModel {
  query: string,
  page: number
}

export interface MedicineShortModel {
  registration_number: string;
  name: string;
  active_ingredients: string;
  manufacturer: string;
  images: string;
  commercialized: boolean;
}

export interface MedicineModel {
  registration_number: string;
  name: string;
  active_ingredients: string;
  manufacturer: string;
  prescription_type: string;
  requires_prescription: boolean;
  affects_driving: boolean;
  has_warning_triangle: boolean;
  substitution_info: string;
  has_notes: boolean;
  materials_inf: boolean;
  documents: string;
  images: string;
  active_ingredients_details: string;
  excipients: string;
  administration_routes: string;
  pharmaceutical_form: string;
  simplified_pharmaceutical_form: string;
  vtm_information: string;
  dosage: string;
  authorization_status: string;
  commercialized: boolean;
  generic: boolean;
  orphan_drug: boolean;
  biosimilar: boolean;
  under_review: boolean;
  ema_approved: boolean;
}

export interface MedicineComparisonRequestModel {
  registrationNumbers: string[];
  inputLanguage: string;
}

export interface MedicineComparisonModel {
  clinicalConsequences: string;
  comparedMedicines: string;
  effect: string;
  evidence: string;
  grade: "low" | "medium" | "high";
  managementRecommendations: string;
  mechanism: string;
  message: string
}